import React, {useState, useEffect} from 'react'
import {TextField, Paper, Button, Card, Typography,} from '@mui/material'

import FileBase from 'react-file-base64'

import {formStyles} from './Styles'
import {useDispatch, useSelector} from 'react-redux'
import{ createPost, updatePost } from '../../features/posts/postthunk'
import {setCurrentId} from '../../features/posts/posts'
const Form = ({handleClose}) => {
  const classes = formStyles()
const dispatch = useDispatch()
 const [postData, setPostData] = useState({Title: '', Message: '', Tags: '',selectedFile:'' })
const id = useSelector((state)=> state.posts.currentId)
const {currentUser} = useSelector((state)=> state.user)
const allPosts = useSelector(state=>(state.posts.prevPosts))


useEffect(() => {
 
if(id){
  const targetPost= allPosts.find(post=>post._id === id)
  setPostData(targetPost)
}
}, [id, allPosts]);


const handleSubmit = (e) =>{
e.preventDefault();
if(id) {
  dispatch(updatePost({...postData, id:id}))
dispatch(setCurrentId(0))
} else {
dispatch(createPost({...postData,Creator:currentUser.Name, CreatorId:currentUser._id}))
}
clearData()
handleClose()
}
const clearData =() =>{
  
  setPostData({Title: '', Message: '', Tags: '',selectedFile:''  })
}

if(!currentUser) return (
  <Card>
    <Typography variant="h6" component="p">
      You must be logged in to like and create a post
    </Typography>
  </Card>
)
  return (
    <Paper sx={classes.paper} elevation={1} >
      <form  autoComplete='off' onSubmit={handleSubmit}>
         <TextField 
         required
        fullWidth
        sx={classes.textfield}
        type='text'
        name='Title'
        variant='outlined'
        label='Title'
        onChange={(e)=>{setPostData({...postData,Title: e.target.value})}}
         value={postData.Title}
        />
         <TextField
         required 
        fullWidth
        sx={classes.textfield}
        type='text'
        name='Message'
        variant='outlined'
        label='Message'
        onChange={(e)=>{setPostData({...postData, Message: e.target.value})}}
        value={postData.Message}
        />
         <TextField 
         required
        fullWidth
        sx={classes.textfield}
        type='text'
        name='Tags'
        variant='outlined'
        label='Tags'
        value={postData.Tags}
        onChange={(e)=>{setPostData({...postData, Tags: e.target.value})}}
        />
        <div style={{marginTop:'1rem'}}>
          <FileBase
          type='file'
          multiple={false}
          value={postData.selectedFile}
          onDone={({base64})=>{setPostData({...postData, selectedFile: base64})}}
           />
        </div>
        <Button type='submit' variant='contained' color='primary' sx={classes.button} fullWidth>Submit</Button>
        <Button variant='contained' color='secondary' onClick={clearData} sx={classes.button} fullWidth>Clear</Button>
      </form>
    </Paper>
  )
}

export default Form